"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _closeButton = require("@design/ui/close-button");
var _utils = require("@design/lib/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Banner = function Banner(_ref) {
  var type = _ref.type,
    message = _ref.message,
    onDismiss = _ref.onDismiss;
  var isWarning = type === "warning";
  var isInfo = type === "info";
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _utils.cn)("flex items-center gap-2 px-3 py-1.5 text-xs", isWarning && "bg-yellow-50 text-yellow-900 border-b border-yellow-200", isInfo && "bg-blue-50 text-blue-900 border-b border-blue-200"),
    "data-sentry-component": "Banner",
    "data-sentry-source-file": "Banner.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-shrink-0",
      children: [isWarning && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
        className: "w-3.5 h-3.5 text-yellow-600"
      }), isInfo && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.InfoIcon, {
        className: "w-3.5 h-3.5 text-blue-600"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex-1",
      children: message
    }), onDismiss && /*#__PURE__*/(0, _jsxRuntime.jsx)(_closeButton.CloseButton, {
      onClick: onDismiss,
      "aria-label": "Dismiss banner",
      size: "icon-xs",
      className: "flex-shrink-0"
    })]
  });
};
var _default = exports.default = Banner;